module.exports = __webpack_public_path__ + "static/img/icon_promotion_modal_close_pc.8728487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_promotion_modal_close_pc.png
// module id = mWt/
// module chunks = 10